var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "stop",
  "use": "stop-usage",
  "viewBox": "0 0 135 135",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 135 135\" id=\"stop\">\r\n<g id=\"stop__x31__left\">\r\n</g>\r\n<g id=\"stop__x31__right\">\r\n</g>\r\n<g id=\"stop__x33_\">\r\n</g>\r\n<g id=\"stop__x38__1_\">\r\n</g>\r\n<g id=\"stop__x37_\">\r\n</g>\r\n<g id=\"stop__x39_\">\r\n</g>\r\n<g id=\"stop__x31_0\">\r\n</g>\r\n<g id=\"stop__x31_1\">\r\n</g>\r\n<g id=\"stop__x34_\">\r\n\t<path d=\"M135,0H0v135h135V0z\" />\r\n</g>\r\n<g id=\"stop__x32_\">\r\n</g>\r\n<g id=\"stop__x32__down\">\r\n</g>\r\n<g id=\"stop_BG\">\r\n</g>\r\n<g id=\"stop_SPIRALS\">\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/components/icon/stop.icon
// module id = 332
// module chunks = 168707334958949